<div class="custom-menu-box w-100">
  <div class="search-box d-flex justify-content-between align-items-center">
    <div class="w-80">
      <input type="text" class="search-input w-100" name="search" placeholder="{{inputPlaceholder || 'Search'}}"
        [ngModel]="inputPlaceholder" #inputSearch (ngModelChange)="valueChange($event)">
    </div>
    <i class="material-icons">
      search
    </i>
  </div>
  <mat-tab-group [disableRipple]="true" (selectedTabChange)="handleTabChange($event)"
    [selectedIndex]="selectedTabIndex">
    <mat-tab *ngFor="let tab of tabs">
      <ng-template mat-tab-label>
        <span *ngIf="tab.value === 'Android' || tab.value === 'iOS' || tab.value === 'Web' ">
          <mat-icon>{{tab.icon}}</mat-icon>
        </span>
        &nbsp;{{tab.value}}
      </ng-template>

      <ng-container *ngIf="!singleSelect">
        <div class="all-checkbox">
          <mat-checkbox [(ngModel)]="selectAll" (ngModelChange)="toggleAll()">
            Select All
          </mat-checkbox>
        </div>
        <div class="list-container" *ngFor="let key of objectKeys(itemsMap)">
          <div class="label">{{listSubHeader[key]}}</div>
          <div class="list-item" *appListFor="let item of itemsMap[key]; itemsAtOnce: 10; intervalLength: 100;">
            <mat-checkbox [(ngModel)]="item.checked" (ngModelChange)="toggleItem()">
              {{item.name}}
            </mat-checkbox>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="singleSelect">
        <div class="list-container" style="border-color:#DDE2EE" *ngFor="let key of objectKeys(itemsMap)">
          <ng-container *ngIf="itemsMap[key].length">
            <div class="label" style="margin-top: 18px;">{{listSubHeader[key]}}</div>
            <div class="list-item"
              *appListFor="let item of itemsMap[key]; itemsAtOnce: 10; intervalLength: 100; let i = index">
              <mat-card style="cursor: pointer;" (click)="selectAppDataID(item, i)">
                <app-platform-icon class="ml-1 mr-2" [platform]="item.os"></app-platform-icon>
                <span>{{item.name}}</span>
              </mat-card>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </mat-tab>
  </mat-tab-group>

</div>
